const { FeatureGuard, BvFrontend, JSBundles } = window;

let promise;

export default () => {
  promise = promise || FeatureGuard.guard('iovation')
    .then((enabled) => {
      if (!enabled) return null;

      return BvFrontend.helpers.requireScript(JSBundles.IovationLoader)
        .then(() => window.IovationLoader.default());
    })
    .catch(() => null);

  return promise;
};
